import { SimpleSearchFilter } from 'module/api/filter/types';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AiQueryAPI, AiQueryRequest } from 'api/ai-query';

export const useProcessAiQueryMutation = (): UseMutationResult<
  SimpleSearchFilter,
  Error,
  AiQueryRequest
> => {
  return useMutation({
    mutationFn: (payload: AiQueryRequest) => {
      return AiQueryAPI.processAiQuery(payload);
    },
  });
};
